module.exports = __webpack_public_path__ + "_assets/img/qrcodeS.9ba7e95c.svg";